import * as styles from "@/pages/AnalyticsPage.styles";

interface GlassTooltipPayload {
  name: string;
  value: number;
  color?: string;
}

interface GlassTooltipProps {
  active?: boolean;
  payload?: GlassTooltipPayload[];
  label?: string;
}

const GlassTooltip = ({ active, payload, label }: GlassTooltipProps) => {
  if (!active || !payload) return null;
  return (
    <div className={styles.glassTooltip}>
      <p className={styles.tooltipLabel}>{label}</p>
      {payload.map((entry: GlassTooltipPayload, index: number) => (
        <div key={index} className={styles.tooltipRow}>
          <span className={styles.tooltipDot} style={{ backgroundColor: entry.color }} />
          <span className={styles.tooltipValue}>
            {entry.name}: {entry.value.toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );
};

export { GlassTooltip };
